var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAv17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1587_44481",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 106,
    height: 106
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    fill: "#EAEAEA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1587_44481)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    fill: "#B4ECD1"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1587_44481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 107.745C82.2711 107.745 106 84.0162 106 54.7451C106 25.474 82.2711 1.74512 53 1.74512C23.7289 1.74512 0 25.474 0 54.7451C0 84.0162 23.7289 107.745 53 107.745Z",
    fill: "#B4ECD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1498 37.8217C64.594 37.8217 73.0607 29.355 73.0607 18.9108C73.0607 8.46667 64.594 0 54.1498 0C43.7057 0 35.239 8.46667 35.239 18.9108C35.239 29.355 43.7057 37.8217 54.1498 37.8217Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8491 56.9447C43.2932 56.9447 51.7599 48.478 51.7599 38.0339C51.7599 27.5897 43.2932 19.123 32.8491 19.123C22.4049 19.123 13.9382 27.5897 13.9382 38.0339C13.9382 48.478 22.4049 56.9447 32.8491 56.9447Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9987 56.9447C83.4429 56.9447 91.9095 48.478 91.9095 38.0339C91.9095 27.5897 83.4429 19.123 72.9987 19.123C62.5546 19.123 54.0879 27.5897 54.0879 38.0339C54.0879 48.478 62.5546 56.9447 72.9987 56.9447Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9143 30.292H53.9122C40.2914 30.292 29.2495 41.3338 29.2495 54.9547V116.762C29.2495 130.383 40.2914 141.425 53.9122 141.425H53.9143C67.5351 141.425 78.577 130.383 78.577 116.762V54.9547C78.577 41.3338 67.5351 30.292 53.9143 30.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.182 44.3186L42.5116 45.672C42.0827 45.8279 41.6096 45.808 41.1953 45.6166C40.781 45.4253 40.459 45.0781 40.2995 44.6505C40.2213 44.4373 40.1859 44.2106 40.1953 43.9836C40.2048 43.7567 40.2589 43.5338 40.3545 43.3277C40.4502 43.1217 40.5856 42.9365 40.7529 42.7828C40.9202 42.6291 41.1161 42.5099 41.3296 42.432L44.9999 41.0787C45.4288 40.9228 45.902 40.9427 46.3163 41.134C46.7306 41.3253 47.0525 41.6725 47.212 42.1001C47.2903 42.3134 47.3257 42.54 47.3162 42.767C47.3068 42.994 47.2527 43.2169 47.157 43.4229C47.0613 43.629 46.926 43.8142 46.7587 43.9679C46.5914 44.1215 46.3954 44.2407 46.182 44.3186Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6449 44.3185L65.3131 45.6719C65.7417 45.8277 66.2145 45.8077 66.6285 45.6164C67.0425 45.4251 67.364 45.0778 67.5231 44.6504C67.6823 44.2214 67.6646 43.7466 67.4739 43.3306C67.2831 42.9145 66.9349 42.5913 66.5059 42.4319L62.8334 41.0786C62.4048 40.9228 61.932 40.9427 61.518 41.1341C61.104 41.3254 60.7825 41.6726 60.6234 42.1C60.5447 42.3127 60.5087 42.5389 60.5174 42.7656C60.5261 42.9922 60.5794 43.215 60.6743 43.421C60.7692 43.627 60.9037 43.8124 61.0703 43.9664C61.2368 44.1204 61.4321 44.24 61.6449 44.3185Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2295 54.5157C51.4808 54.5157 52.4951 53.0958 52.4951 51.3443C52.4951 49.5927 51.4808 48.1729 50.2295 48.1729C48.9782 48.1729 47.9639 49.5927 47.9639 51.3443C47.9639 53.0958 48.9782 54.5157 50.2295 54.5157Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5976 54.5157C58.8489 54.5157 59.8633 53.0958 59.8633 51.3443C59.8633 49.5927 58.8489 48.1729 57.5976 48.1729C56.3464 48.1729 55.332 49.5927 55.332 51.3443C55.332 53.0958 56.3464 54.5157 57.5976 54.5157Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5616 59.8536C33.872 56.7546 32.4219 53.1801 29.3229 51.8697C26.2238 50.5593 22.6493 52.0093 21.3389 55.1084C20.0286 58.2074 21.4786 61.782 24.5776 63.0924C27.6767 64.4027 31.2512 62.9527 32.5616 59.8536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1917 59.8546C85.5021 56.7556 84.0521 53.181 80.953 51.8707C77.854 50.5603 74.2794 52.0103 72.9691 55.1094C71.6587 58.2084 73.1087 61.783 76.2078 63.0933C79.3068 64.4037 82.8814 62.9537 84.1917 59.8546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9144 58.049C46.4782 58.0504 46.049 58.1575 45.6633 58.3611C45.2776 58.5648 44.947 58.8588 44.6999 59.2182C44.4527 59.5775 44.2964 59.9914 44.2442 60.4244C44.1921 60.8574 44.2456 61.2966 44.4004 61.7044C45.1474 63.6846 46.48 65.3901 48.2206 66.5938C49.9613 67.7976 52.0274 68.4424 54.1438 68.4424C56.2601 68.4424 58.3263 67.7976 60.0669 66.5938C61.8076 65.3901 63.1402 63.6846 63.8872 61.7044C64.0424 61.2965 64.0963 60.8571 64.0443 60.4238C63.9924 59.9905 63.8361 59.5763 63.5889 59.2167C63.3417 58.857 63.011 58.5627 62.6251 58.359C62.2392 58.1552 61.8096 58.0481 61.3732 58.0469L46.9144 58.049Z",
    fill: "#B4ECD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5491 81.2197H29.2495V117.891H78.5491V81.2197Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5491 89.2002H29.2495V94.4531H78.5491V89.2002Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5491 97.3555H29.2495V102.608H78.5491V97.3555Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7351 135.672C22.2742 135.668 20.8743 135.086 19.8411 134.053C18.8079 133.02 18.2255 131.62 18.2209 130.16V86.7317C18.2255 85.2709 18.8079 83.8712 19.8411 82.8384C20.8743 81.8056 22.2742 81.2237 23.7351 81.2197H29.2492V130.16C29.2447 131.62 28.6622 133.02 27.6291 134.053C26.5959 135.086 25.1959 135.668 23.7351 135.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0637 135.671C82.6013 135.671 81.1987 135.09 80.1646 134.056C79.1305 133.022 78.5496 131.619 78.5496 130.157V81.219H84.0637C85.5262 81.219 86.9287 81.8 87.9628 82.8341C88.9969 83.8682 89.5779 85.2707 89.5779 86.7332V130.159C89.5773 131.621 88.9961 133.023 87.9621 134.057C86.928 135.09 85.5258 135.671 84.0637 135.671Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1587_44481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAv17);
export default __webpack_public_path__ + "static/media/Av17.ce63ae59c71af1912d2d54faa02cd3bc.svg";
export { ForwardRef as ReactComponent };